import { useState } from "react";

const OPTIONS = [
  { lang: "en", label: "English" },
  { lang: "ka", label: "ქართული" },
];

export default function LanguageChooserModal({ onChoose }) {
  const [hovered, setHovered] = useState(null);

  return (
    <div
      style={{
        position: "fixed",
        inset: 0,
        zIndex: 100000,
        background: "rgba(10,12,18,0.75)",
        backdropFilter: "blur(4px)",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        padding: 20,
      }}
    >
      <div
        style={{
          background: "#fff",
          borderRadius: 20,
          padding: "40px 32px",
          maxWidth: 400,
          width: "100%",
          textAlign: "center",
          boxShadow: "0 24px 60px rgba(0,0,0,0.35)",
        }}
      >
        <div
          style={{
            width: 56,
            height: 56,
            borderRadius: "50%",
            background: "#0a0c12",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            margin: "0 auto 20px",
          }}
        >
          <span className="material-symbols-outlined" style={{ color: "#fff", fontSize: 28 }}>
            language
          </span>
        </div>
        <h2 style={{ fontFamily: "Geist, sans-serif", fontSize: 21, fontWeight: 800, color: "#0a0c12", margin: "0 0 4px" }}>
          Choose your language
        </h2>
        <p style={{ fontFamily: "Geist, sans-serif", fontSize: 15, fontWeight: 600, color: "#5c5f60", margin: "0 0 28px" }}>
          აირჩიეთ ენა
        </p>
        <div style={{ display: "flex", flexDirection: "column", gap: 12 }}>
          {OPTIONS.map(({ lang, label }) => (
            <button
              key={lang}
              type="button"
              onClick={() => onChoose(lang)}
              onMouseEnter={() => setHovered(lang)}
              onMouseLeave={() => setHovered(null)}
              style={{
                width: "100%",
                padding: "14px 20px",
                borderRadius: 12,
                border: "1.5px solid #0a0c12",
                background: hovered === lang ? "#0a0c12" : "#fff",
                color: hovered === lang ? "#fff" : "#0a0c12",
                fontFamily: "Geist, sans-serif",
                fontSize: 16,
                fontWeight: 700,
                cursor: "pointer",
                transition: "background 0.15s, color 0.15s",
              }}
            >
              {label}
            </button>
          ))}
        </div>
      </div>
    </div>
  );
}
